import type { Theme } from "@mui/material";
import type { CalculatorIconType } from "shared/CalculatorIcons";
import { NavigationTypes } from "web_myplann/Utils/device";

export type QuickCalculatorVariant =
	keyof Theme["dashboard"]["quickCalculator"]["tints"];

export type QuickCalculator = {
	type: CalculatorIconType;
	navigationType: keyof typeof NavigationTypes;
	variant: QuickCalculatorVariant;
};

export const QUICK_CALCULATORS: QuickCalculator[] = [
	{
		type: "travelInsurance",
		navigationType: NavigationTypes.TravelInsuranceCalculatorScreen,
		variant: "blue",
	},
	{
		type: "propertyInsurance",
		navigationType: NavigationTypes.PropertyInsuranceCalculatorScreen,
		variant: "orange",
	},
	{
		type: "carMotoInsurance",
		navigationType: NavigationTypes.VehicleInsuranceCalculatorScreen,
		variant: "green",
	},
	{
		type: "consumerLoan",
		navigationType: NavigationTypes.ConsumerLoanCalculatorScreen,
		variant: "purple",
	},
	{
		type: "mortgage",
		navigationType: NavigationTypes.MortgageCalculatorScreen,
		variant: "blue",
	},
	{
		type: "pensionAnnuity",
		navigationType: NavigationTypes.PensionAnnuityCalculatorScreen,
		variant: "rose",
	},
];
